// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"cfKw3","rc-tabs-bar":"PYmvz","rc-tabs-tab":"eHjn-","rc-tabs-tab-active":"cJ3ve","terms":"_1yK4z","orderHistory-navigation":"gewAm","base":"_1H61N"};